import { render, staticRenderFns } from "./MongoViewEdit.vue?vue&type=template&id=09d970fe&scoped=true"
import script from "./MongoViewEdit.vue?vue&type=script&lang=ts"
export * from "./MongoViewEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d970fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09d970fe')) {
      api.createRecord('09d970fe', component.options)
    } else {
      api.reload('09d970fe', component.options)
    }
    module.hot.accept("./MongoViewEdit.vue?vue&type=template&id=09d970fe&scoped=true", function () {
      api.rerender('09d970fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/mongoviews/MongoViewEdit.vue"
export default component.exports